import {environment} from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {ScheduleAsset} from '../models/scheduleAsset.model';
import {Injectable} from '@angular/core';
import {ColumnsType} from '../models/columns-type.model';
import {DataSourceRowNumber} from '../models/data-source-row-number.type';
import {Relation} from '../models/relation.model';
import {CalculateColumnModel} from '../models/calculate-column.model';
import { DataSourceConditionalColumn } from '../models/conditional-column.model';
import {PreviewDataSourceInfo} from '../models/preview-data-source-info.model';
import { ColumnDataSourceUpdate } from '../models/confilict-column.model';
import { CustomDateColumns } from '../models/custom-date-columns.model';
import { ProcessingDataSource } from '../models/processing-data-source.model';

@Injectable()
export class DataSourceApi {


  readonly baseUrl = environment.baseUrl;
  readonly api = environment.api;

  constructor(private http: HttpClient) { }

  // main data-source
  getDataSourceRelations(workspaceId: string, dataSourceId: string): Observable<any> {
    const bodyRequest = {
      workspaceId,
      dataSourceId,
    };
    return this.http.post(`${this.api}/Relation/GetDataSourceRelations/`, bodyRequest);
  }

  getDataSourceTableContent(workspaceId, dataSourceId, rowNumber): Observable<any> {
    const bodyRequest = {
      workspaceId,
      dataSourceId,
      rowNumber,
    };
    return this.http.post(`${this.api}/DataSource/GetDataSourceData/`, bodyRequest);
  }

  getDatasourceColumnsDataTypes(workspaceId, dataSourceId): Observable<any> {
    const bodyRequest = {
      workspaceId,
      dataSourceId,
    };
    return this.http.post(`${this.api}/DataSource/GetDataSourceColumnsDataTypes/`, bodyRequest);
  }

  updateDatasourceData(workspaceId: string, dataSourceId: string, columns: ColumnDataSourceUpdate[]): Observable<any> {
    const bodyRequest = {
      workspaceId,
      dataSourceId,
      columns,
    };
    return this.http.post(`${this.api}/DataSource/UpdateDataSourceData`,bodyRequest);
  }

  checkUpdateDataSourceData(workspaceId: string, dataSourceId: string, 
    ConnectionId?: string, RowNumber?: string): Observable<any> {
    const bodyRequest = {
      workspaceId,
      dataSourceId,
      ConnectionId,
      RowNumber
    };
    return this.http.post(`${this.api}/DataSource/CheckUpdateDataSourceData`,bodyRequest);
  }

  /**
   *check whether the data source has been used in the dashboard or not
   *
   * @param workspaceId
   * @param dataSources
   */
  checkDeleteDataSource(workspaceId: string, dataSources: string[]): Observable<any> {
    const bodyRequest = {
      workspaceId,
      dataSources,
    };
    return this.http.post(`${this.api}/DataSource/CheckDeleteDataSource`,bodyRequest);
  }

  updateDatasourceColumnsDataTypes(workspaceId: string, dataSourceId: string,
                                   columnsTypes: ColumnsType): Observable<any> {
    const bodyRequest = {
      workspaceId,
      dataSourceId,
      columnsTypes,
    };
    return this.http.post(`${this.api}/DataSource/UpdateDataSourceColumnsDataTypes/`, bodyRequest);
  }

  checkUpdateDatasourceColumnDataTypes(workspaceId: string, dataSourceId: string,
                                       columnsTypes: ColumnsType): Observable<any> {
    const bodyRequest = {
      workspaceId,
      dataSourceId,
      columnsTypes,
    };
    return this.http.post(`${this.api}/DataSource/CheckUpdateDataSourceColumnsDataTypes/`, bodyRequest);
  }

  updateDatasource(body: any): Observable<any> {
    return this.http.post<any>(`${this.api}/DataSource/UpdateDataSource/`, body);
  }

  createReplacementTable(previewDataSourceInfo: Partial<PreviewDataSourceInfo>, workspaceId: string,
                         columnsTypes: ColumnsType, sheetName: string): Observable<any> {
    const bodyRequest = {
      workspaceId,
      dataSourceId: previewDataSourceInfo.dataSourceId,
      dbConnectionType: previewDataSourceInfo.dbConnectionType,
      filePath: previewDataSourceInfo.filePath,
      fileName: previewDataSourceInfo.fileName,
      columnsTypes: this.arrayToObjectConvertor(columnsTypes),
      sheetName,
    };
    return this.http.post(`${this.api}/DataSource/CreateReplacementTable`, bodyRequest);
  }

  // sql-server
  getSqlServerConnection(workspaceId: string, dataSourceId: string): Observable<any> {
    const bodyRequest = {
      workspaceId,
      dataSourceId,
    };
    return this.http.post<any>(this.api + '/DataSource/GetSqlServerConnection', bodyRequest);
  }

  updateSqlServerConnection(requestBody: any): Observable<any> {
    return this.http.post<any>(`${this.api}/DataSource/UpdateSQLServerConnection/`, requestBody);
  }

  // oracle
  getOracleConnection(workspaceId: string, dataSourceId: string): Observable<any> {
    const bodyRequest = {
      workspaceId,
      dataSourceId,
    };
    return this.http.post<any>(this.api + '/DataSource/GetOracleConnection', bodyRequest);
  }


  updateOracleConnection(requestBody: any) {
    return this.http.post<any>(`${this.api}/DataSource/UpdateOracleConnection/`, requestBody);

  }

  // web-service
  getWebServiceConnection(workspaceId: string, dataSourceId: string): Observable<any> {
    const bodyRequest = {
      workspaceId,
      dataSourceId,
    };
    return this.http.post<any>(this.api + '/DataSource/GetWebServiceConnection', bodyRequest);
  }

  updateWebServiceConnection(requestBody: any): Observable<any> {
    return this.http.post<any>(`${this.api}/DataSource/UpdateWebServiceConnection/`, requestBody);
  }

  // relation
  getDataSourcesForRelation(body: any): Observable<any> {
    return this.http.post(`${this.api}/Relation/GetDatasourcesForRelation/`, body);
  }

  addToRelationsModel(workspaceId: string, sourceDataSourceId: string,
                      destinationDataSourceId: string): Observable<any> {
    const bodyRequest = {
      workspaceId,
      sourceDataSourceId,
      destinationDataSourceId,
    };
    return this.http.post<any>(`${this.api}/Relation/AddToRelationsModel/`, bodyRequest);
  }

  createRelation(relation: Relation): Observable<any> {
    return this.http.post(this.api + '/Relation/CreateRelation', relation);
  }


  activateRelation(relation: Relation, workSpaceId: string): Observable<any> {
    const bodyRequest = {
      relationId: relation.relationId,
      workspaceId: workSpaceId,
      sourceDataSourceId: relation.sourceDataSourceId,
      destinationDataSourceId: relation.destinationDataSourceId,
    };
    return this.http.post(this.api + '/Relation/ActivateRelation', bodyRequest);
  }

  deactivateRelation(relation: Relation, workSpaceId: string): Observable<any> {
    const bodyRequest = {
      relationId: relation.relationId,
      workspaceId: workSpaceId,
      sourceDataSourceId: relation.sourceDataSourceId,
      destinationDataSourceId: relation.destinationDataSourceId,
    };
    return this.http.post(this.api + '/Relation/DeActivateRelation', bodyRequest);
  }

  deleteDataSourceFromModel(workspaceId: string, sourceDataSourceId: string,
                            destinationDataSourceId: string): Observable<any> {
    const bodyRequest = {
      workspaceId,
      sourceDataSourceId,
      destinationDataSourceId,
    };
    return this.http.post<any>(`${this.api}/Relation/DeleteFromRelationsModel/`, bodyRequest);
  }

  deleteRelation(workspaceId: string, relationId: string,
                 sourceDataSourceId: string, destinationDataSourceId: string): Observable<any> {
    const bodyRequest = {
      relationId,
      workspaceId,
      sourceDataSourceId,
      destinationDataSourceId,
    };
    return this.http.post(this.api + '/Relation/DeleteRelation', bodyRequest);
  }

  getDataSourceData(dataSourceId: string, workspaceId: string, rowNumber: DataSourceRowNumber): Observable<any> {
    const bodyRequest = {
      workspaceId,
      dataSourceId,
      rowNumber,
    };
    return this.http.post(this.api + '/DataSource/GetDataSourceData', bodyRequest);
  }

  updateRelation(relation: Relation): Observable<any> {
    return this.http.post(this.api + '/Relation/UpdateRelation', relation);
  }

  // schedule
  getScheduleOfAsset(id: string,workspaceId: string): Observable<any> {
    const bodyRequest = {
      assetId: id,
      workspaceId,
    };
    return this.http.post(this.api + '/Schedule/GetScheduleOfAsset', bodyRequest);
  }

  getScheduleHistory(
    workspaceId: string,
    datasourceId: string,
    pageNumber: number,
    pageSize: number,
    needCount: boolean): Observable<any> {
    const bodyRequest = {
      workspaceId,
      datasourceId,
      pageNumber,
      pageSize,
      needCount,
    };
    return this.http.post(this.api + '/DataSource/GetDataSourceUpdateHistory',bodyRequest);
  }

  addSchedule(newSchedule: ScheduleAsset): Observable<any> {
    return this.http.post(this.api + '/Schedule/AddSchedule', newSchedule);
  }

  updateSchedule(newSchedule: ScheduleAsset): Observable<any> {
    return this.http.post(this.api + '/Schedule/UpdateSchedule', newSchedule);
  }

  stopSchedule(workspaceId: string, assetId: string, scheduleId: string): Observable<any> {
    const bodyRequest = {
      workspaceId,
      assetId,
      scheduleId,
    };
    return this.http.post(`${this.api}/Schedule/StopSchedule`,bodyRequest);
  }

  stopManualUpdate(workspaceId: string, dataSourceId: string): Observable<any> {
    const bodyRequest = {
      workspaceId,
      dataSourceId,
    };
    return this.http.post(`${this.api}/DataSource/StopDataSourceManualUpdate`,bodyRequest);
  }

  deactivationSchedule(schedule: ScheduleAsset): Observable<any> {
    const bodyRequest = {
      workspaceId: schedule.workspaceId,
      assetId: schedule.assetId,
      scheduleId: schedule.scheduleId,
    };
    return this.http.post(this.api + '/Schedule/DeactiveSchedule', bodyRequest);
  }

  activationSchedule(schedule: ScheduleAsset): Observable<any> {
    const bodyRequest = {
      workspaceId: schedule.workspaceId,
      assetId: schedule.assetId,
      scheduleId: schedule.scheduleId,
    };
    return this.http.post(this.api + '/Schedule/ActivateSchedule', bodyRequest);
  }

  //calculate column
  createCalculateColumn(calculateColumn: Partial<CalculateColumnModel>): Observable<any> {
    return this.http.post(this.api + '/DataSource/CreateCalculateColumn', calculateColumn);
  }

  updateCalculateColumn(calculateColumn: Partial<CalculateColumnModel>): Observable<any> {
    return this.http.post(this.api + '/DataSource/UpdateCalculateColumn', calculateColumn);
  }

  deleteCalculateColumn(columnId: string, workspaceId: string, dataSourceId: string): Observable<any> {
    const bodyRequest = {
      workspaceId,
      columnId,
      dataSourceId,
    };
    return this.http.post(this.api + '/DataSource/DeleteCalculateColumn', bodyRequest);
  }

  getCalculateColumnExpression(columnId: string, workspaceId: string, dataSourceId: string): Observable<any> {
    const bodyRequest = {
      workspaceId,
      columnId,
      dataSourceId,
    };
    return this.http.post(this.api + '/DataSource/GetColumnExpression', bodyRequest);
  }

  // conditional column
  createConditionalColumn(conditionalColumn: Partial<DataSourceConditionalColumn>): Observable<any> {
    return this.http.post(this.api + '/DataSource/CreateConditionalColumn', conditionalColumn);
  }

  updateConditionalColumn(conditionalColumn: Partial<DataSourceConditionalColumn>): Observable<any> {
    return this.http.post(this.api + '/DataSource/UpdateConditionalColumn', conditionalColumn);
  }

  getConditionalColumn(dataSourceId: string, workspaceId: string, columnId: string): Observable<any> {
    const bodyRequest = {
      workspaceId,
      columnId,
      dataSourceId,
    };
    return this.http.post(this.api + '/DataSource/GetConditionalColumn', bodyRequest);
  }

  deleteConditionalColumn(columnId: string, workspaceId: string, dataSourceId: string): Observable<any> {
    const bodyRequest = {
      workspaceId,
      columnId,
      dataSourceId,
    };
    return this.http.post(this.api + '/DataSource/DeleteConditionalColumn', bodyRequest);
  }

  // customdate columns
  getCustomDateColumns(dataSourceId: string, columnId: string): Observable<any> {
    const bodyRequest = {
      dataSourceId,
      columnId,
    };
    return this.http.post(this.api + '/DataSource/GetDateColumns', bodyRequest);
  }

  createCustomDateColumns(dataSourceId: string, columnId: string): Observable<any> {
    const bodyRequest = {
      columnId,
      dataSourceId,
    };
    return this.http.post(this.api + '/DataSource/CreateDateColumns', bodyRequest);
  }

  setCustomDateColumns( dataSourceId: string, columnId: string, customDateColumns: CustomDateColumns[]): Observable<any> {
    const bodyRequest = {
      columnId,
      dataSourceId,
      customDateColumns,
    };
    return this.http.post(this.api + '/DataSource/SetDateColumns', bodyRequest);
  }

  deleteCustomDateColumn(columnId: string, dataSourceId: string, workspaceId: string): Observable<any> {
    const bodyRequest = {
      columnId,
      dataSourceId,
      workspaceId,
    };
    return this.http.post(this.api + '/DataSource/DeleteCustomDateColumn', bodyRequest);
  }

  updateCustomDateColumnName(columnId: string, dataSourceId: string, workspaceId: string, name: string): Observable<any> {
    const bodyRequest = {
      columnId,
      dataSourceId,
      workspaceId,
      name,
    };
    return this.http.post(this.api + '/DataSource/UpdateCustomDateName', bodyRequest);
  }
  // dashboard
  makeNewDashboard(newDashboard: any) {
    return this.http.post<any>(`${this.api}/Dashboard/CreateDashboard`, newDashboard);
  }

  addBookmark(assetId: string, workspaceId: string): Observable<any>{
    const bodyRequest = {
      assetId,
      assetType: 'DataSource',
      workspaceId,
    };
    return this.http.post(`${this.api}/Bookmark/AddBookmark`,bodyRequest);
  }

  removeBookmark(assetId: string, workspaceId: string): Observable<any>{
    const bodyRequest = {
      assetId,
      assetType: 'DataSource',
      workspaceId,
    };
    return this.http.post(`${this.api}/Bookmark/RemoveBookmark`,bodyRequest);
  }

  deleteDataSource(workspaceId: string, dataSourceId: string): Observable<any> {
    const bodyRequest = {
      workspaceId,
      dataSourceId,
    };
    return this.http.post(`${this.api}/DataSource/DeleteDataSource`,bodyRequest);
  }

  duplicateDatasource(workspaceId: string, dataSourceId: string): Observable<any> {
    return this.http.post(`${this.api}/DataSource/DuplicateDataSource`, { workspaceId, dataSourceId });
  }

  changeDataSourceName(workspaceId: string, dataSourceId: string, name: string): Observable<any>{
    const bodyRequest = {
      workspaceId,
      dataSourceId,
      name,
    };
    return this.http.post(`${this.api}/DataSource/ChangeDataSourceName`,bodyRequest);
  }

  arrayToObjectConvertor(columnsTypes: any): any {
    const obj = {};
    for(const key in columnsTypes) {
      if(key) {
        obj[key] = columnsTypes[key];
      }
    }
    return obj;
  }

  getProcessingDataSources(): Observable<any> {
    return this.http.get(`${this.api}/DataSource/GetProcessingDataSources`);
  }

  retryProcessing(dataSource: ProcessingDataSource): Observable<any> {
      const bodyRequest = {
      dataSourceId: dataSource.id
    };
      return this.http.post(`${this.api}/DataSource/RetryProcessing`, bodyRequest);
  }

  changeCompletionStatus(workspaceId: string, dataSourceId: string): Observable<any> {
    const bodyRequest = {
      workspaceId,
      dataSourceId,
    };
    return this.http.post(`${this.api}/DataSource/ChangeCompletionStatusError`, bodyRequest);
  }

  cancelDataSourceUploadProgress(workspaceId: string, dataSourceId: string): Observable<any> {
    const bodyRequest = {
      workspaceId,
      dataSourceId,
    };
    return this.http.post(`${this.api}/DataSource/CancellCreateDataSource`, bodyRequest);
  }
}
